import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService,
         SuccessResponse,
         setRef,
         CopyToClipboard,
} from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';
    const redirectUrl = 'https://www.captureone.com/en/products-plans/single-user/redeem-student-discount';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center"></div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                    } />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>

            {/* Custom Phase one block */}
            <div className="sid-how-to-use-code-container">
                <div className="sid-how-to-use-code">
                    <FormattedHTMLMessage id="step.success.howToUseCode" defaultMessage="How to use your code to access the student price:" />
                </div>

                <ol className="sid-success-info-list">
                    <li className="sid-success-info-list__li">
                        <FormattedHTMLMessage
                            id="step.success.visitStore"
                            defaultMessage="Visit the "
                        />
                        <a href={redirectUrl} className="sid-store-link" target="_blank" rel="noopener noreferrer">store</a>
                    </li>
                    <li className="sid-success-info-list__li">
                        <FormattedHTMLMessage
                            id="step.success.studentPrice"
                            defaultMessage="Enter your unique code at checkout to apply the student price."
                        />
                    </li>
                    <li className="sid-success-info-list__li">
                        <FormattedHTMLMessage
                            id="step.success.completePurchase"
                            defaultMessage="Complete purchase to receive your license code"
                        />
                    </li>
                </ol>

                <button
                    onClick={() => window.open(redirectUrl, '_blank')}
                    type="submit"
                    className={`sid-success-store-btn sid-btn`}
                    aria-label="submit"
                    ref={button => setRef('submitButton', button)}
                >
                    <FormattedHTMLMessage
                        id="step.success.storeButton"
                        defaultMessage="Go to store"
                    />
                </button>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage={"We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com"} />
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to {companyName} customer service.
                    `}
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
